// TRON (TRC20) Address Validation
export const isValidTRC20 = (address) => {
    const regex = /^T[a-zA-Z0-9]{33}$/;
    return regex.test(address);
};

// BSC (BEP20) Address Validation
export const isValidBEP20 = (address) => {
    const regex = /^0x[a-fA-F0-9]{40}$/;
    return regex.test(address);
};

export const validateChainAddress = (chainType, address) => {

    if (!address) return "Please enter wallet address.";

    switch (chainType) {
        case "TRC20 USDT":
            return isValidTRC20(address)
                ? ""
                : "Invalid TRC20 address. Example: Txxxxxx (34 characters)";

        case "BEP20 USDT":
            return isValidBEP20(address)
                ? ""
                : "Invalid BEP20 address. Example: 0xXXXXX (42 characters)";

        default:
            return "Unsupported chain type.";
    }
};
